import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Content, Section, TabMenu, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import InquiryList from "../../components/myPage/InquiryList";
import Inquiry from "../../components/myPage/Inquiry";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const MyInquiry = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const [currentTab, clickTab] = useState(0);
  const menuArr = [
    { name: "내가 문의한 내역", content: <InquiryList /> },
    {
      name: "1:1 문의하기",
      content: <Inquiry clickTab={clickTab} />,
    },
  ];

  const selectMenuHandler = (index) => {
    // parameter로 현재 선택한 인덱스 값을 전달해야 하며, 이벤트 객체(event)는 쓰지 않는다
    // 해당 함수가 실행되면 현재 선택된 Tab Menu 가 갱신.
    clickTab(index);
  };
  return (
    <OnlyHeaderLayout title="1:1 문의내역">
      <Section className="nonePaddingTop">
        <Content>
          <TabMenu>
            {menuArr.map((el, index) => (
              <li
                key={index}
                className={index === currentTab ? "pointer focused" : "pointer"}
                onClick={() => selectMenuHandler(index)}
              >
                {el.name}
              </li>
            ))}
          </TabMenu>
          <Desc>{menuArr[currentTab].content}</Desc>
        </Content>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default MyInquiry;
const Desc = styled.div`
  margin-top: 2rem;
`;
